/** One route list for the website top navigation. */
export interface NavItem {
  to: string;
  label: string;
}

export const navItems: readonly NavItem[] = [
  { to: '/', label: 'Leaderboards' },
  { to: '/party', label: 'Party' },
  { to: '/friends', label: 'Friends' },
  { to: '/runs', label: 'My runs' },
  { to: '/me', label: 'Profile' },
];
